import { createContext } from 'react';
import { AppUserFullInfo } from '../types';

interface IUserContextInterface {
  data: AppUserFullInfo;
  refreshUserInfo: (preventPageRefresh?: boolean) => Promise<AppUserFullInfo>;
  updateUserData: (updates: Partial<AppUserFullInfo>) => void;
}

export const UserInfoContext = createContext<IUserContextInterface>(
  {} as IUserContextInterface,
);
